import { render, staticRenderFns } from "./fi_tab_bar.vue?vue&type=template&id=3fb3b5c1&scoped=true&"
import script from "./fi_tab_bar.vue?vue&type=script&lang=js&"
export * from "./fi_tab_bar.vue?vue&type=script&lang=js&"
import style0 from "./fi_tab_bar.vue?vue&type=style&index=0&id=3fb3b5c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb3b5c1",
  null
  
)

export default component.exports